<div class="  print:tw-bg-white print:tw-min-h-auto">
	<div class="tw-relative tw-isolate tw-h-full tw-bg-gradient-to-r tw-from-[#747373] tw-to-[#5E5E5E] print:tw-bg-none print:tw-h-auto">
			<img src="assets/img/header.png" alt="" class="tw-w-full tw-h-full tw-object-cover tw-object-right md:tw-object-center tw-shadow-2xl print:tw-hidden">
			<div class="tw-absolute md:tw-top-10 tw-top-2 tw-right-10 print:tw-static print:tw-text-black">
					<h1 class="tw-text-1xl tw-tracking-tight tw-text-white sm:tw-text-3xl print:tw-text tw-capitalize print:tw-text-black">
							Welcome, {{user?.firstName}} {{user?.lastName}}
					</h1>
					<h5 class="tw-text tw-tracking-tight tw-text-white sm:tw-text-2xl tw-capitalize print:tw-text print:tw-text-black">
							{{headNode?.name}}
					</h5>
			</div>
	</div>

<div *ngIf="shouldInclude(this.decoded.role)" class="tw-w-full tw-p-2 tw-text-left tw-mb-1 print:tw-hidden">
	<h2 class="tw-text-2xl mt-2 tw-text-[#243670] tw-font-bold tw-ml-6">Quick Stats</h2>
</div>
<div *ngIf="shouldInclude(this.decoded.role)" class="tw-grid  md:tw-grid-cols-7 sm:tw-grid-cols-1 tw-space-x-1 tw-mx-6 tw-gap-2 tw-pb-2 print:tw-px-0 print:tw-mt-0">
	<div *ngFor="let item of quickStatsCards | originalOrder">
		<div *ngIf="item.value.show">
			<app-quick-stats
				[isLoading]="item.value.isLoading"
				[iconClass]="item.value.iconClass"
				[statValue]="item.value.statValue"
				[statDescription]="item.value.statDescription"
				[iconImage]="item.value.iconImage">
			</app-quick-stats>
		</div>
	</div>
</div>
<div class="tw-w-full tw-p-2 tw-text-left tw-mb-1  print:tw-hidden">
	<h2 class="tw-text-2xl tw-text-[#243670] tw-font-bold ml-4">Quick Links</h2>
</div>
<div class="tw-mx-auto tw-px-6 lg:tw-px-8 print:tw-px-0 print:tw-hidden">
	<div class="tw-grid tw-grid-cols-1 md:tw-grid-cols-2 lg:tw-grid-cols-3 xl:tw-grid-cols-4 tw-gap-4 tw-text-center tw-justify-center tw-items-center print:tw-grid-cols-3 print:tw-gap-2 mb-4 tw-bg-[#E9ECEF]">
			<div (click)="navigateTo('/dashboard')" class="tw-bg-white tw-shadow-lg tw-p-4 tw-w-full tw-h-56 tw-flex tw-flex-col tw-items-center tw-justify-center hover:tw--translate-y-1 hover:tw-shadow-gray-400 tw-transition tw-transform tw-duration-100 tw-cursor-pointer print:tw-shadow-none print:tw-h-auto print:tw-p-2">
				<i class="fa fa-user tw-text-6xl tw-mb-2 tw-text-[#243670] print:tw-text-black"></i>
					<h3 class="tw-font-bold tw-text-xl print:tw-text-lg">
							Enter Scores
					</h3>
					<p class="tw-text-gray-700 print:tw-text-black">
							Add or update scores
					</p>
			</div>
			<div (click)="navigateTo(dashboard.toLowerCase())" class="tw-bg-white tw-shadow-lg tw-p-4 tw-w-full tw-h-56 tw-flex tw-flex-col tw-items-center tw-justify-center hover:tw--translate-y-1 hover:tw-shadow-gray-400 tw-transition tw-transform tw-duration-100 tw-cursor-pointer print:tw-shadow-none print:tw-h-auto print:tw-p-2">
					<i class="fa fa-line-chart tw-text-6xl tw-mb-2 tw-text-[#243670] print:tw-text-black"></i>
					<h3 class="tw-font-bold tw-text-xl print:tw-text-lg">
							Results and Progress
					</h3>
					<p class="tw-text-gray-700 print:tw-text-black">
							View student progress
					</p>
			</div>
			<!-- <div (click)="navigateTo('/resources')" class="tw-bg-white tw-shadow-lg tw-p-4 tw-w-full tw-h-56 tw-flex tw-flex-col tw-items-center tw-justify-center hover:tw--translate-y-1 hover:tw-shadow-gray-400 tw-transition tw-transform tw-duration-100 tw-cursor-pointer print:tw-shadow-none print:tw-h-auto print:tw-p-2">
				<i class="fa fa-folder-open-o tw-text-6xl tw-mb-2 tw-text-[#243670] print:tw-text-black"></i>
				<h3 class="tw-font-bold tw-text-xl print:tw-text-lg">
						Resources
				</h3>
				<p class="tw-text-gray-700 print:tw-text-black">
						Download resources
				</p>
		</div> -->
			<div (click)="navigateTo('https://support.confidentlearners.com/hc/en-ca')" class="tw-bg-white tw-shadow-lg tw-p-4 tw-w-full tw-h-56 tw-flex tw-flex-col tw-items-center tw-justify-center hover:tw--translate-y-1 hover:tw-shadow-gray-400 tw-transition tw-transform tw-duration-100 tw-cursor-pointer print:tw-shadow-none print:tw-h-auto print:tw-p-2">
					<i class="fa fa-book tw-text-6xl tw-mb-2 tw-text-[#243670] print:tw-text-black"></i>
					<h3 class="tw-font-bold tw-text-xl print:tw-text-lg">
							Knowledge Base
					</h3>
					<p class="tw-text-gray-700 print:tw-text-black">
							Help articles and resources
					</p>
			</div>
			<div (click)="navigateTo('https://academy.confidentlearners.com/')" class="tw-bg-white tw-shadow-lg tw-p-4 tw-w-full tw-h-56 tw-flex tw-flex-col tw-items-center tw-justify-center hover:tw--translate-y-1 hover:tw-shadow-gray-400 tw-transition tw-transform tw-duration-100 tw-cursor-pointer print:tw-shadow-none print:tw-h-auto print:tw-p-2">
					<i class="fa fa-graduation-cap tw-text-6xl tw-mb-2 tw-text-[#243670] print:tw-text-black"></i>
					<h3 class="tw-font-bold tw-text-xl print:tw-text-lg">
							Learning Management System
					</h3>
					<p class="tw-text-gray-700 print:tw-text-black">
							Access LMS content
					</p>
			</div>

	</div>
</div>
<ng-template #content let-modal>
  <div class="modal-header">
    <h4 class="modal-title">Modal title</h4>
    <button type="button" class="close" aria-label="Close" (click)="modal.dismiss('Cross click')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body">
    <iframe width="100%" height="100%" [src]="iframeUrl"></iframe>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.close('Close click')">Close</button>
  </div>
</ng-template>
